import { defineComponent as _defineComponent } from 'vue'
import VueMultiselect from "vue-multiselect"
import SingleSelect from 'primevue/select';
import MultiSelect from 'primevue/multiselect';

import { ref, watch, useSlots, computed } from 'vue'


const r = 'required'


export default /*@__PURE__*/_defineComponent({
  __name: 'MazSelectInput',
  props: {
  errors: {
    type: Object,
    default: () => ({}),
  },
  disabled: Boolean,
  isSuccess: Boolean,
  inputLabel: String,
  staticLabel: [Boolean, String],
  options: Array,
  labelBy: String,
  trackBy: String,
  allowEmpty: Boolean,
  placeholder: {
    type: String,
    default: '',
  },
  pagination: Object,
  showObserveVisibility: Boolean,
  modelValue: Object,
  type: {
    type: String,
    default: 'text',
  },
  rules: {
    type: String,
    default: '',
  },
  setValue: {},
  name: {},
  multiple: {},
},
  emits: ['getItems', 'clearMultiselect'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const eSlotsResolver = (acc, key) => {
  acc[key] = key
  return acc
}

const getESlots = keys => keys
  .reduce(eSlotsResolver, {})

const eSlots = computed(() => {
  return getESlots([...Object.keys(useSlots())])
})

const props = __props

const model = ref(props.modelValue)

watch(() => props.modelValue, () => model.value = props.modelValue)

const isRequired = 
  typeof props.rules == 'string' ? props.rules.includes(r) : props.rules?.[r]

const isValid = ref(null)

const emit = __emit

async function visibilityChanged (isVisible) {
  if( isVisible ) {
    await emit('getItems')
  }
}



const __returned__ = { eSlotsResolver, getESlots, eSlots, props, r, model, isRequired, isValid, emit, visibilityChanged, get VueMultiselect() { return VueMultiselect }, get SingleSelect() { return SingleSelect }, get MultiSelect() { return MultiSelect }, ref, watch, useSlots, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})